import {
  FETCH_BONUSES_DATA_SUCCESS,
  FETCH_BONUSES_DATA_FAILURE,
  FETCH_LEADERBOARD_DATA_SUCCESS,
  FETCH_LEADERBOARD_DATA_FAILURE,
  FETCH_ORGANIZATION_DATA_SUCCESS,
  FETCH_ORGANIZATION_DATA_FAILURE,
  FETCH_PARTICIPATION_DATA_SUCCESS,
  FETCH_PARTICIPATION_DATA_FAILURE,
  FETCH_TOP_WORDS_DATA_SUCCESS,
  FETCH_TOP_WORDS_DATA_FAILURE,
} from '../constants/actions';

function analyticsReducer(state: any, action: any) {
  switch (action.type) {
    case FETCH_BONUSES_DATA_SUCCESS: {
      const bonuses = {
        ...state.bonuses,
        data: action.data.totals_by_hashtag,
        bonusesGiven: action.data.bonuses_given_count,
        bonusesReceived: action.data.bonuses_received_count,
        pointsGiven: action.data.points_given,
        uniqueHashtags: action.data.unique_hashtags,
        requestStatus: 'success',
      };

      return { ...state, bonuses };
    }
    case FETCH_BONUSES_DATA_FAILURE: {
      const bonuses = {
        ...state.bonuses,
        requestStatus: 'error',
      };

      return { ...state, bonuses };
    }
    case FETCH_LEADERBOARD_DATA_SUCCESS: {
      const leaderboard = {
        ...state.leaderboard,
        data: action.data.data,
        requestStatus: 'success',
      };

      return { ...state, leaderboard };
    }
    case FETCH_LEADERBOARD_DATA_FAILURE: {
      const leaderboard = {
        ...state.leaderboard,
        requestStatus: 'error',
      };

      return { ...state, leaderboard };
    }
    case FETCH_ORGANIZATION_DATA_SUCCESS: {
      const organization = {
        ...state.organization,
        data: action.data,
        requestStatus: 'success',
      };

      return { ...state, organization };
    }
    case FETCH_ORGANIZATION_DATA_FAILURE: {
      const organization = {
        ...state.organization,
        requestStatus: 'error',
      };

      return { ...state, organization };
    }
    case FETCH_PARTICIPATION_DATA_SUCCESS: {
      const participation = {
        ...state.participation,
        data: [
          {
            id: 'participation',
            color: 'hsl(200, 67%, 61%)',
            data: action.data.result.engagements,
          },
        ],
        totalEngagement: action.data.result.total_engagement,
        requestStatus: 'success',
      };

      return { ...state, participation };
    }
    case FETCH_PARTICIPATION_DATA_FAILURE: {
      const participation = {
        ...state.participation,
        requestStatus: 'error',
      };

      return { ...state, participation };
    }
    case FETCH_TOP_WORDS_DATA_SUCCESS: {
      const words = action.data.result.slice(0, 60);
      const topWords = {
        ...state.topWords,
        data: words,
        requestStatus: 'success',
      };

      return { ...state, topWords };
    }
    case FETCH_TOP_WORDS_DATA_FAILURE: {
      const topWords = {
        ...state.topWords,
        requestStatus: 'error',
      };

      return { ...state, topWords };
    }
    default:
      return state;
  }
}

export default analyticsReducer;
